export enum FooterBookingVariant {
    FooterCalendar = "FooterCalendar",
    Default = "Default"
}